// React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Assets
import { menuListData } from "../../assets/menuListData";
import { ProductType, menuListType } from "../../assets/Type";
// Recoil
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import {
  templateState,
  orderWindowState,
  isAdminMode,
  cartState,
  isTooltipView,
  isOrderState,
} from "../../atom/menu";
// Import Swiper React components
import SwiperCore from "swiper";
import { Virtual, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// Components
import ControllerOrder from "../../components/menu/common/ControllerOrder";
import IntroOrdered, { PopupLanguageList } from "./IntroOrdered";
import PopupOption from "./PopupOption";
import OrderConfirm from "./OrderConfirm";
function MenuMain() {
  // 메뉴 페이지

  // 메뉴 템플릿 template (전역으로 관리됨)
  // 0 = 세로 이미지 (디폴트)
  // 1 = 가로 메뉴 설명
  // templateToggle = false 세로 텍스트
  const navigate = useNavigate();
  // swiper
  const [swiperRef, setSwiperRef] = useState<SwiperCore>();

  const slideTo = (index: number) => {
    if (swiperRef) swiperRef.slideTo(index);
    if (index === 0) setSelectMenu(0);
    // if (swiperRef) swiperRef.slideTo(index - 1, 0);
  };

  // Recoil State
  const template = useRecoilValue(templateState);
  const [isTooltip, setIsTooltip] = useRecoilState(isTooltipView);
  const [orderWindow, setOrderWindowState] = useRecoilState(orderWindowState);
  const [cartData, setCartData] = useRecoilState(cartState);
  const [isOrder, setIsOrder] = useRecoilState(isOrderState);
  const resetCart = useResetRecoilState(cartState);
  const setIsAdminPopup = useSetRecoilState(isAdminMode);

  // useState
  // const categoryList = ["전채요리", "주요요리", "버거", "파스타", "음료"];
  // 메뉴 변경
  const categoryList = ["추천메뉴", "덮밥", "짜글이", "추가", "사이드", "음료"];
  const [selectMenu, setSelectMenu] = useState<number>(0);
  const [activeSwiper, setActiveSwiper] = useState<number>(0);
  const [templateToggle, setTemplateToggle] = useState<boolean>(false);
  const [langPopup, setLangPopup] = useState<boolean>(false);
  const [servicePopup, setServicePopup] = useState<boolean>(false);
  const [optionPopupView, setOptionPopupView] = useState<menuListType | null>(
    null
  );

  // Function
  useEffect(() => {
    if (activeSwiper) {
      if (activeSwiper < 6) {
        setSelectMenu(0);
      } else if (activeSwiper < 17) {
        setSelectMenu(1);
      } else if (activeSwiper < 19) {
        setSelectMenu(2);
      } else if (activeSwiper < 23) {
        setSelectMenu(3);
      } else if (activeSwiper < 38) {
        setSelectMenu(4);
      } else if (activeSwiper < 50) {
        setSelectMenu(5);
      } else {
        setSelectMenu(0);
      }
    }
  }, [activeSwiper]);
  useEffect(() => {
    if (template === 0 && templateToggle) {
      document
        .getElementById("vertical-image")
        ?.addEventListener("scroll", gnbFix);
    }
    if (template === 1 && templateToggle) {
      document
        .getElementById("horizontal-image")
        ?.addEventListener("scroll", gnbFix);
    }
    if (!templateToggle) {
      document
        .getElementById("vertical-text")
        ?.addEventListener("scroll", gnbFix);
    }
    return () => {
      if (template === 0 && templateToggle) {
        document
          .getElementById("vertical-image")
          ?.removeEventListener("scroll", gnbFix);
      }
      if (template === 1 && templateToggle) {
        document
          .getElementById("horizontal-image")
          ?.removeEventListener("scroll", gnbFix);
      }
      if (!templateToggle) {
        document
          .getElementById("vertical-text")
          ?.removeEventListener("scroll", gnbFix);
      }
    };
  }, [template, templateToggle]);

  useEffect(() => {
    // 관리자에서 템플릿 변경시 이미지 템플릿으로 리셋
    setSelectMenu(0);
    setTemplateToggle(true);
  }, [template]);

  function gnbFix() {
    if (template === 0 && templateToggle) {
      const top = document.getElementById("vertical-image")!.scrollTop;
      if (top < 750) {
        setSelectMenu(0);
      } else if (top < 2220) {
        setSelectMenu(1);
      } else if (top < 2660) {
        setSelectMenu(2);
      } else if (top < 3400) {
        setSelectMenu(3);
      } else if (top < 5240) {
        setSelectMenu(4);
      } else {
        setSelectMenu(5);
      }
    }
    if (template === 1 && templateToggle) {
      const left = document.getElementById("horizontal-image")!.scrollLeft;
      if (left < 6830) {
        setSelectMenu(0);
      } else if (left < 10230) {
        setSelectMenu(1);
      } else if (left < 11250) {
        setSelectMenu(2);
      } else if (left < 12950) {
        setSelectMenu(3);
      } else if (left < 12950) {
        setSelectMenu(4);
      } else {
        setSelectMenu(4);
      }
    }
    if (!templateToggle) {
      const top = document.getElementById("vertical-text")!.scrollTop;
      if (top < 300) {
        setSelectMenu(0);
      } else if (top < 800) {
        setSelectMenu(1);
      } else if (top < 1000) {
        setSelectMenu(2);
      } else if (top < 1300) {
        setSelectMenu(3);
      } else if (top < 1940) {
        setSelectMenu(4);
      } else {
        setSelectMenu(5);
      }
    }
  }

  const categoryClickEvent = (idx: number) => {
    // 선택된 메뉴에 따라 스크롤 위치 변경
    if (idx === 0) {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    } else if (idx === 1) {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 750,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 6830,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 300,
          behavior: "smooth",
        });
      }
    } else if (idx === 2) {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 2220,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 10230,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 800,
          behavior: "smooth",
        });
      }
    } else if (idx === 3) {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 2660,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 11250,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 1000,
          behavior: "smooth",
        });
      }
    } else if (idx === 4) {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 3400,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 11250,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 1300,
          behavior: "smooth",
        });
      }
    } else {
      if (template === 0 && templateToggle) {
        document.getElementById("vertical-image")!.scrollTo({
          top: 5240,
          behavior: "smooth",
        });
      }
      if (template === 1 && templateToggle) {
        document.getElementById("horizontal-image")!.scrollTo({
          left: 12950,
          behavior: "smooth",
        });
      }
      if (!templateToggle) {
        document.getElementById("vertical-text")!.scrollTo({
          top: 1940,
          behavior: "smooth",
        });
      }
    }
  };

  function calcTotalAmount() {
    // 총액 계산
    if (cartData) {
      let amt = 0 as number;
      let option = 0 as number;
      cartData.reduce((acc, cur) => {
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
          amt = acc + (cur.price + option) * cur.ea;
        } else {
          amt = acc + cur.price * cur.ea;
        }
        return amt;
      }, amt);
      let total = amt as number;
      return total;
    } else {
      return 0;
    }
  }
  const calcTotalEa = () => {
    let total = 0 as number;
    if (cartData) {
      cartData.reduce((acc, cur) => {
        total = acc + cur.ea;
        return total;
      }, total);
    }
    return total;
  };
  function calcProductPrice(idx: number) {
    if (cartData) {
      let price = 0 as number;
      let option = 0 as number;
      price = cartData[idx].price;
      if (cartData[idx].option) {
        cartData[idx].option!.reduce((acc, cur) => {
          option = acc + cur.price * cur.ea;
          return option;
        }, option);
      }
      return (price + option) * cartData[idx].ea;
    } else {
      return 0;
    }
  }
  const popupControl = () => {
    setLangPopup(!langPopup);
  };
  const serviceControl = () => {
    setServicePopup(!servicePopup);
  };
  const optionControl = () => {
    setOptionPopupView(null);
  };

  const menuClickEvent = (val: menuListType) => {
    // 메뉴 클릭 이벤트
    if (val.isOption) {
      // 옵션이 있는 상품인 경우 isOption : true === > 옵션추가 팝업 띄우기
      if (val.isSale) {
        // 품절이 아닌 경우
        setOptionPopupView(val);
      }
    } else {
      // 옵션이 없는 상품인 경우 isOption : false === > 주문 추가하기
      if (val.isSale) {
        // 품절이 아닌 경우
        const prev = [...cartData!];
        if (prev.find((v) => v.name === val.name)) {
          const prevMenu = prev.find((v) => v.name === val.name);
          prev.splice(
            prev.findIndex((v) => v.name === val.name),
            1,
            { ...prevMenu!, ea: prevMenu!.ea + 1 }
          );
          // 이미 추가한 메뉴인 경우
        } else {
          // 새로운 메뉴인 경우
          prev!.push({
            name: val.name,
            ea: 1,
            price: val.salePrice,
            option: null,
          });
        }
        setCartData([...prev]);
      }
    }
    // 장바구니 화면 노출
    setOrderWindowState(true);
  };

  const deleteMenu = (menu: ProductType) => {
    // 장바구니에서 해당 메뉴 삭제
    if (cartData) {
      const arr = [...cartData];
      arr.splice(
        cartData?.findIndex((v) => v.name === menu.name),
        1
      );
      setCartData(arr);
    }
  };

  const tripleClick = () => {
    // 로고 3번 클릭 시, 관리자 페이지 이동 (1초안에 3번 클릭)
    setIsAdminPopup(true);
  };
  useEffect(() => {
    const logoEle = document.getElementById("triple");
    if (logoEle) {
      // let clicks = 0;
      // let timer,
      //   timeout = 1000;
      logoEle.addEventListener("click", function (e) {
        tripleClick();
        // clicks++;
        // timer = setTimeout(function () {
        //   if (clicks == 3 || clicks == 4) tripleClick();
        //   clicks = 0;
        // }, timeout);
      });
    }
  }, []);

  const returnList = (type: string) => {
    // 메뉴 리스트 노출
    return (
      <>
        {templateToggle
          ? template === 0
            ? // 세로이미지 (Default)
              menuListData
                .filter((value) => value.category === type)
                .map((v) =>
                  cartData!.find((val) => val.name === v.name) &&
                  cartData![cartData!.findIndex((val) => val.name === v.name)]
                    .ea > 0 ? (
                    <div className='vertical-image-menu-wrap-2'>
                      <div className='img-center-crop'>
                        <img
                          src={`/assets/images/menuimg/${v.img}`}
                          alt='menu'
                        />
                      </div>
                      {!v.isSale ? (
                        <div className='soldout-bg'>
                          <span className='TO-title-2 text-color-gray-5'>
                            일시품절
                          </span>
                        </div>
                      ) : (
                        <>
                          {cartData!.find((val) => val.name === v.name) &&
                            cartData![
                              cartData!.findIndex((val) => val.name === v.name)
                            ].ea > 0 && (
                              <div className='hover-bg'>
                                <ControllerOrder
                                  value={
                                    cartData![
                                      cartData!.findIndex(
                                        (val) => val.name === v.name
                                      )
                                    ].ea
                                  }
                                  menu={v}
                                  data={cartData!}
                                />
                              </div>
                            )}
                        </>
                      )}
                      <div className='vertical-image-menu-content-box'>
                        <div className='flex col h-auto' style={{ gap: 4 }}>
                          <div className='wrap-b'>
                            {v?.bedg.map((v) => {
                              return v === "맵기1" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : v === "맵기2" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : v === "맵기3" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : (
                                <span className='bedg TO-option-3'>{v}</span>
                              );
                            })}
                          </div>
                          <div className='TO-menu-1-big text-elipsis-2 w-100'>
                            {v?.name}
                          </div>
                        </div>
                        <div className='type-3-price'>
                          <span className='TO-price-5-strike text-color-gray-6'>
                            {v.isDiscount && v?.salePrice.toLocaleString()}
                          </span>
                          <span className='TO-price-3 text-color-gray-3'>
                            {v?.price.toLocaleString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className='vertical-image-menu-wrap-2'
                      onClick={() => {
                        menuClickEvent(v);
                      }}
                    >
                      <div className='img-center-crop'>
                        <img
                          src={`/assets/images/menuimg/${v.img}`}
                          alt='menu'
                        />
                      </div>
                      {!v.isSale && (
                        <div className='soldout-bg'>
                          <span className='TO-title-2 text-color-gray-5'>
                            일시품절
                          </span>
                        </div>
                      )}
                      <div className='vertical-image-menu-content-box'>
                        <div className='flex col h-auto' style={{ gap: 4 }}>
                          <div className='wrap-b'>
                            {v?.bedg.map((v) => {
                              return v === "맵기1" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : v === "맵기2" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : v === "맵기3" ? (
                                <span className='bedg TO-option-3'>
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                  <img
                                    src={"/assets/images/menu/spicy.png"}
                                    alt='spicy icon'
                                  />
                                </span>
                              ) : (
                                <span className='bedg TO-option-3'>{v}</span>
                              );
                            })}
                          </div>
                          <div className='TO-menu-1-big text-elipsis-2 w-100'>
                            {v?.name}
                          </div>
                        </div>
                        <div className='type-3-price'>
                          <span className='TO-price-5-strike text-color-gray-6'>
                            {v.isDiscount && v?.salePrice.toLocaleString()}
                          </span>
                          <span className='TO-price-3 text-color-gray-3'>
                            {v?.price.toLocaleString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                )
            : // 가로메뉴설명

              menuListData
                // .filter((value) => value.category === type)
                .map((v) =>
                  cartData!.find((val) => val.name === v.name) &&
                  cartData![cartData!.findIndex((val) => val.name === v.name)]
                    .ea > 0 ? (
                    <SwiperSlide>
                      <div className='vertical-image-menu-wrap'>
                        <div className='img-center-crop'>
                          <img
                            src={`/assets/images/menuimg/${v.img}`}
                            alt='menu'
                          />
                        </div>
                        {!v.isSale ? (
                          <div className='soldout-bg'>
                            <span className='TO-title-2 text-color-gray-5'>
                              일시품절
                            </span>
                          </div>
                        ) : (
                          <>
                            {cartData!.find((val) => val.name === v.name) &&
                              cartData![
                                cartData!.findIndex(
                                  (val) => val.name === v.name
                                )
                              ].ea > 0 && (
                                <div className='hover-bg'>
                                  <ControllerOrder
                                    value={
                                      cartData![
                                        cartData!.findIndex(
                                          (val) => val.name === v.name
                                        )
                                      ].ea
                                    }
                                    menu={v}
                                    data={cartData!}
                                  />
                                </div>
                              )}
                          </>
                        )}
                        <div className='vertical-image-menu-content-box'>
                          <div className='botton-bg-gradation'></div>
                          <div className='flex col h-auto' style={{ gap: 4 }}>
                            <div className='wrap-b'>
                              {v?.bedg.map((v) => {
                                return v === "맵기1" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : v === "맵기2" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : v === "맵기3" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : (
                                  <span className='bedg TO-option-3'>{v}</span>
                                );
                              })}
                            </div>
                            <div className='TO-menu-1-big text-elipsis-3 w-100'>
                              {v?.name}
                            </div>
                          </div>
                          <div>
                            <div className='TO-option-3 text-elipsis-2 text-color-gray-6'>
                              {v?.isDescription}
                            </div>
                            <div className='type-3-price'>
                              <span className='TO-price-5-strike text-color-gray-6'>
                                {v.isDiscount && v?.salePrice.toLocaleString()}
                              </span>
                              <span
                                className='TO-body-3 text-color-gray-3'
                                style={{ fontWeight: 500 }}
                              >
                                {v?.price.toLocaleString()}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ) : (
                    <SwiperSlide>
                      <div
                        className='vertical-image-menu-wrap'
                        onClick={() => {
                          menuClickEvent(v);
                        }}
                      >
                        <div className='img-center-crop'>
                          <img
                            src={`/assets/images/menuimg/${v.img}`}
                            alt='menu'
                          />
                        </div>

                        {!v.isSale && (
                          <div className='soldout-bg'>
                            <span className='TO-title-2 text-color-gray-5'>
                              일시품절
                            </span>
                          </div>
                        )}
                        <div className='vertical-image-menu-content-box'>
                          <div className='botton-bg-gradation'></div>
                          <div className='flex col h-auto' style={{ gap: 4 }}>
                            <div className='wrap-b'>
                              {v?.bedg.map((v) => {
                                return v === "맵기1" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : v === "맵기2" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : v === "맵기3" ? (
                                  <span className='bedg TO-option-3'>
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                    <img
                                      src={"/assets/images/menu/spicy.png"}
                                      alt='spicy icon'
                                    />
                                  </span>
                                ) : (
                                  <span className='bedg TO-option-3'>{v}</span>
                                );
                              })}
                            </div>
                            <div className='TO-menu-1-big text-elipsis-3 w-100'>
                              {v?.name}
                            </div>
                          </div>
                          <div>
                            <div className='TO-option-3 text-elipsis-2 text-color-gray-6'>
                              {v?.isDescription}
                            </div>
                            <div className='type-3-price'>
                              <span className='TO-price-5-strike text-color-gray-6'>
                                {v.isDiscount && v?.salePrice.toLocaleString()}
                              </span>
                              <span
                                className='TO-body-3 text-color-gray-3'
                                style={{ fontWeight: 500 }}
                              >
                                {v?.price.toLocaleString()}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                )
          : // 세로텍스트
            menuListData
              .filter((value) => value.category === type)
              .map((v) => (
                <div
                  className='vertical-text-menu-content-box'
                  onClick={() => {
                    menuClickEvent(v);
                  }}
                >
                  <div className='TO-button-3 w-100'>{v?.name}</div>
                  <div
                    className='flex col'
                    style={{
                      width: "84px",
                      justifyContent: "center",
                      alignItems: "flex-start",
                    }}
                  >
                    <span className='TO-price-5-strike text-color-gray-6'>
                      {v.isDiscount && v?.salePrice.toLocaleString()}
                    </span>
                    <span className='TO-body-3 text-color-gray-5'>
                      {v?.price.toLocaleString()}
                    </span>
                  </div>
                  {!v.isSale && (
                    <div
                      className='soldout-bg-text'
                      style={{ borderRadius: 10 }}
                    >
                      <span className='TO-title-2 text-color-gray-6'>
                        일시품절
                      </span>
                    </div>
                  )}
                </div>
              ))}
      </>
    );
  };
  return (
    <>
      <div className='menu-page'>
        <div>
          {/* 공통 헤더 */}
          <div className='menu-list-common-header' style={{ padding: 0 }}>
            <div
              id='triple'
              style={{
                backgroundColor: "#eee",
                zIndex: 9,
                padding: "0 2rem 0 1.25rem",
              }}
            >
              <img
                className='logo-img'
                src={"/assets/images/menu/logo.png"}
                alt='vd company logo'
              />
            </div>
            <div className='flow-text-box'>
              <div className='flow-gradation'></div>
              <div className='flow-text TO-title-5'>
                어서오세요, 1992 덮밥&짜글이에 오신 것을 환영합니다. 매장 오픈
                시간 10:00 -18:00
              </div>
            </div>
            {!orderWindow && (
              <div className='table-info'>
                <span className='TO-title-2-small'>1번 창가테이블</span>
                <span className='TO-title-5'>/1층</span>
              </div>
            )}
          </div>
          {templateToggle ? (
            // toggle true = 이미지
            <>
              {template === 0 ? (
                <div className='menu-grid-type-a'>
                  {/* 세로이미지 */}
                  <div className='big-category-vertical'>
                    <div
                      className='flex col'
                      style={{
                        gap: 20,
                        alignItems: "flex-end",
                        paddingRight: 12,
                      }}
                    >
                      {categoryList.map((v, i) => {
                        return i === selectMenu ? (
                          <div
                            className='TO-button-1 pointer'
                            style={{ color: "#010101" }}
                            key={i}
                            onClick={() => {
                              categoryClickEvent(i);
                            }}
                          >
                            {v}
                          </div>
                        ) : (
                          <div
                            className='TO-button-1 text-color-gray-6 pointer'
                            key={i}
                            onClick={() => {
                              categoryClickEvent(i);
                            }}
                          >
                            {v}
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <div
                        className='basic-btn gray pointer'
                        style={{ height: 64 }}
                        onClick={() => {
                          setServicePopup(true);
                        }}
                      >
                        <img
                          src={"/assets/images/menu/call.svg"}
                          alt='bell icon'
                        />
                        <span className='TO-button-2'>직원호출</span>
                      </div>
                      <div
                        className='basic-btn gray pointer'
                        style={{ height: 64, marginTop: 8 }}
                        onClick={() => {
                          popupControl();
                        }}
                      >
                        <span className='TO-button-2'>language</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className='wrap-a w-100'
                    style={{ paddingRight: 24, maxHeight: 710, maxWidth: 984 }}
                  >
                    <div
                      className='flex row justify-content-between'
                      style={{
                        height: "auto",
                        marginTop: 30,
                        paddingBottom: 24,
                      }}
                    >
                      <div className='small-category-horizontal'>
                        {categoryList.map((v, i) => {
                          return i === selectMenu ? (
                            <div
                              className='category-box-active TO-button-2'
                              style={{ color: "#010101" }}
                              key={i}
                              onClick={() => {
                                categoryClickEvent(i);
                              }}
                            >
                              {v}
                            </div>
                          ) : (
                            <div
                              className='category-box TO-button-2'
                              key={i}
                              onClick={() => {
                                categoryClickEvent(i);
                              }}
                            >
                              {v}
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className='flex row align-items-center'
                        style={{ gap: 16, width: "auto" }}
                      >
                        {templateToggle ? (
                          <div
                            className='small-category-icon-box'
                            style={{ backgroundColor: "#F8F8F8" }}
                          >
                            <img
                              src={"/assets/images/menu/template.svg"}
                              alt='template icon'
                            />
                          </div>
                        ) : (
                          <div
                            className='small-category-icon-box pointer'
                            onClick={() => {
                              setTemplateToggle(true);
                              setSelectMenu(0);
                            }}
                          >
                            <img
                              src={"/assets/images/menu/template.svg"}
                              alt='template icon'
                            />
                          </div>
                        )}
                        {!templateToggle ? (
                          <div
                            className='small-category-icon-box'
                            style={{ backgroundColor: "#F8F8F8" }}
                          >
                            <img
                              src={"/assets/images/menu/menu.svg"}
                              alt='menu icon'
                            />
                          </div>
                        ) : (
                          <div
                            className='small-category-icon-box pointer'
                            onClick={() => {
                              setTemplateToggle(false);
                              setSelectMenu(0);
                            }}
                          >
                            <img
                              src={"/assets/images/menu/menu.svg"}
                              alt='menu icon'
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* 세로이미지 메뉴리스트 */}
                    <div
                      className='flex col scroll'
                      id='vertical-image'
                      style={{
                        gap: "16px",
                        height: "fit-content",
                        paddingBottom: 50,
                      }}
                    >
                      {categoryList.map((v, i) => {
                        return (
                          <div
                            className='flex col'
                            style={{
                              gap: "8px",
                              paddingBottom: "8px",
                              height: "fit-content",
                            }}
                          >
                            <div
                              className='flex row align-items-center'
                              style={{ gap: 16 }}
                            >
                              <span className='TO-button-2'>{v}</span>

                              {/* <span className='TO-body-3'>{v}</span> */}
                            </div>
                            <div className='menu-gird-wrap'>
                              {returnList(v)}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className='flex col'
                  style={{
                    paddingRight: "32px",
                  }}
                >
                  {/* 가로 메뉴 설명 */}
                  <div
                    className='big-category-horizontal'
                    style={{ gap: 32, paddingLeft: 32 }}
                  >
                    <div
                      className='flex row align-items-center'
                      style={{ gap: 32 }}
                    >
                      {categoryList.map((v, i) => {
                        return i === selectMenu ? (
                          <div
                            className='TO-button-1 relative pointer'
                            style={{
                              color: "#010101",
                            }}
                            key={i}
                            onClick={() => {
                              v === "추천메뉴"
                                ? slideTo(0)
                                : v === "덮밥"
                                ? slideTo(6)
                                : v === "짜글이"
                                ? slideTo(17)
                                : v === "추가"
                                ? slideTo(19)
                                : v === "사이드"
                                ? slideTo(23)
                                : slideTo(38);
                              // categoryClickEvent(i);
                            }}
                          >
                            <div className='big-category-active-bedg'></div>
                            {v}
                          </div>
                        ) : (
                          <div
                            className='TO-button-1 text-color-gray-6 pointer'
                            key={i}
                            onClick={() => {
                              v === "추천메뉴"
                                ? slideTo(0)
                                : v === "덮밥"
                                ? slideTo(6)
                                : v === "짜글이"
                                ? slideTo(17)
                                : v === "추가"
                                ? slideTo(19)
                                : v === "사이드"
                                ? slideTo(23)
                                : slideTo(38);
                              // categoryClickEvent(i);
                            }}
                          >
                            {v}
                          </div>
                        );
                      })}
                    </div>

                    <div
                      className='flex row align-items-center'
                      style={{ gap: 16, width: "auto" }}
                    >
                      {templateToggle ? (
                        <div
                          className='small-category-icon-box'
                          style={{ backgroundColor: "#F8F8F8" }}
                        >
                          <img
                            src={"/assets/images/menu/template.svg"}
                            alt='template icon'
                          />
                        </div>
                      ) : (
                        <div
                          className='small-category-icon-box pointer'
                          onClick={() => {
                            setTemplateToggle(true);
                            setSelectMenu(0);
                          }}
                        >
                          <img
                            src={"/assets/images/menu/template.svg"}
                            alt='template icon'
                          />
                        </div>
                      )}
                      {!templateToggle ? (
                        <div
                          className='small-category-icon-box'
                          style={{ backgroundColor: "#F8F8F8" }}
                        >
                          <img
                            src={"/assets/images/menu/menu.svg"}
                            alt='menu icon'
                          />
                        </div>
                      ) : (
                        <div
                          className='small-category-icon-box pointer'
                          onClick={() => {
                            setTemplateToggle(false);
                            setSelectMenu(0);
                          }}
                        >
                          <img
                            src={"/assets/images/menu/menu.svg"}
                            alt='menu icon'
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className='wrap-a w-100'
                    style={{
                      paddingLeft: 32,
                      paddingBottom: 12,
                      marginTop: 14,
                    }}
                  >
                    <div
                      className='flex row justify-content-between'
                      style={{ height: "auto" }}
                    >
                      <div className='small-category-horizontal'>
                        {categoryList.map((v, i) => {
                          return i === selectMenu ? (
                            <div
                              className='category-box-active TO-button-2'
                              style={{ color: "#010101", height: 59 }}
                              key={i}
                              onClick={() => {
                                v === "추천메뉴"
                                  ? slideTo(0)
                                  : v === "덮밥"
                                  ? slideTo(6)
                                  : v === "짜글이"
                                  ? slideTo(17)
                                  : v === "추가"
                                  ? slideTo(19)
                                  : v === "사이드"
                                  ? slideTo(23)
                                  : slideTo(38);
                                // categoryClickEvent(i);
                              }}
                            >
                              {v}
                            </div>
                          ) : (
                            <div
                              className='category-box TO-button-2'
                              style={{ height: 59 }}
                              key={i}
                              onClick={() => {
                                v === "추천메뉴"
                                  ? slideTo(0)
                                  : v === "덮밥"
                                  ? slideTo(6)
                                  : v === "짜글이"
                                  ? slideTo(17)
                                  : v === "추가"
                                  ? slideTo(19)
                                  : v === "사이드"
                                  ? slideTo(23)
                                  : slideTo(38);
                                // categoryClickEvent(i);
                              }}
                            >
                              {v}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  {/* 가로 메뉴 설명 메뉴리스트 */}
                  <div className='relative w-100'>
                    <div
                      className='menu-wrap-row scroll-w'
                      id='horizontal-image'
                    >
                      <Swiper
                        slidesPerView={orderWindow ? 2.65 : 3.6}
                        spaceBetween={20}
                        onSwiper={setSwiperRef}
                        loop={false}
                        virtual
                        modules={[Virtual]}
                        className='mySwiper'
                        onSlideChange={(e) => setActiveSwiper(e.activeIndex)}
                      >
                        {categoryList.map((v, i) => {
                          return (
                            <div>{returnList(v)}</div>
                            // <div className='menu-wrap-row-inner'>
                            //   {returnList(v)}
                            // </div>
                          );
                        })}
                      </Swiper>
                    </div>
                    <div
                      className='flow-gradation'
                      style={{ height: "100%", top: 0, right: 0 }}
                    ></div>
                  </div>
                  <div className='menu-bottom-absolute'>
                    <div
                      className='basic-btn gray pointer'
                      onClick={() => {
                        setServicePopup(true);
                      }}
                    >
                      <img
                        src={"/assets/images/menu/call.svg"}
                        alt='bell icon'
                      />
                      <span className='TO-button-2'>직원호출</span>
                    </div>
                    <div
                      className='basic-btn gray pointer'
                      onClick={() => {
                        popupControl();
                      }}
                    >
                      <span className='TO-button-2'>language</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            // toggle flase = 텍스트
            <div
              className='flex col'
              style={{
                paddingRight: "32px",
              }}
            >
              {/* 세로 텍스트 */}
              <div
                className='big-category-horizontal'
                style={{ gap: 32, paddingLeft: 32 }}
              >
                <div
                  className='flex row align-items-center'
                  style={{ gap: 32 }}
                >
                  {categoryList.map((v, i) => {
                    return i === selectMenu ? (
                      <div
                        className='TO-button-2 relative pointer'
                        style={{
                          color: "#010101",
                        }}
                        key={i}
                        onClick={() => {
                          categoryClickEvent(i);
                        }}
                      >
                        <div className='big-category-active-bedg-line'></div>
                        {v}
                      </div>
                    ) : (
                      <div
                        className='TO-button-2 text-color-gray-6 pointer'
                        key={i}
                        onClick={() => {
                          categoryClickEvent(i);
                        }}
                      >
                        {v}
                      </div>
                    );
                  })}
                </div>

                <div
                  className='flex row align-items-center'
                  style={{ gap: 16, width: "auto" }}
                >
                  {templateToggle ? (
                    <div
                      className='small-category-icon-box'
                      style={{ backgroundColor: "#F8F8F8" }}
                    >
                      <img
                        src={"/assets/images/menu/template.svg"}
                        alt='template icon'
                      />
                    </div>
                  ) : (
                    <div
                      className='small-category-icon-box pointer'
                      onClick={() => {
                        setTemplateToggle(true);
                        setSelectMenu(0);
                      }}
                    >
                      <img
                        src={"/assets/images/menu/template.svg"}
                        alt='template icon'
                      />
                    </div>
                  )}
                  {!templateToggle ? (
                    <div
                      className='small-category-icon-box'
                      style={{ backgroundColor: "#F8F8F8" }}
                    >
                      <img
                        src={"/assets/images/menu/menu.svg"}
                        alt='menu icon'
                      />
                    </div>
                  ) : (
                    <div
                      className='small-category-icon-box pointer'
                      onClick={() => {
                        setTemplateToggle(false);
                        setSelectMenu(0);
                      }}
                    >
                      <img
                        src={"/assets/images/menu/menu.svg"}
                        alt='menu icon'
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                className='wrap-a w-100'
                style={{
                  paddingLeft: 32,
                  paddingBottom: 12,
                  marginTop: 14,
                }}
              >
                <div
                  className='flex row justify-content-between'
                  style={{ height: "auto" }}
                >
                  <div className='small-category-horizontal'>
                    {categoryList.map((v, i) => {
                      return i === selectMenu ? (
                        <div
                          className='category-box-active TO-button-2'
                          style={{ color: "#010101" }}
                          key={i}
                          onClick={() => {
                            categoryClickEvent(i);
                          }}
                        >
                          {v}
                        </div>
                      ) : (
                        <div
                          className='category-box TO-button-2'
                          key={i}
                          onClick={() => {
                            categoryClickEvent(i);
                          }}
                        >
                          {v}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* 세로 텍스트 메뉴리스트 */}
              <div
                className='flex col scroll'
                id='vertical-text'
                style={{
                  gap: "16px",
                  height: "500px",
                  paddingBottom: 500,
                  paddingLeft: 24,
                }}
              >
                {categoryList.map((v, i) => {
                  return (
                    <div
                      className='flex col'
                      style={{
                        gap: "8px",
                        paddingBottom: "8px",
                        height: "fit-content",
                      }}
                    >
                      <div
                        className='flex row align-items-center'
                        style={{ gap: 16 }}
                      >
                        <span className='TO-body-1 text-color-gray-6'>{v}</span>
                      </div>
                      <div className='menu-gird-wrap'>{returnList(v)}</div>
                    </div>
                  );
                })}
              </div>
              <div className='menu-bottom-absolute'>
                <div
                  className='basic-btn gray pointer'
                  style={{ height: 64 }}
                  onClick={() => {
                    setServicePopup(true);
                  }}
                >
                  <img src={"/assets/images/menu/call.svg"} alt='bell icon' />
                  <span className='TO-button-2'>직원호출</span>
                </div>
                {/* <div className='basic-btn gray' style={{ height: 64 }}>
                  <span className='TO-button-2'>주문내역</span>
                </div> */}
                <div
                  className='basic-btn gray pointer'
                  style={{ height: 64 }}
                  onClick={() => {
                    popupControl();
                  }}
                >
                  <span className='TO-button-2'>language</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {orderWindow ? (
          <div className='order-list'>
            <div className='flex col'>
              <div
                className='flex row justify-content-between'
                style={{ height: "auto" }}
              >
                <span className='TO-title-3 text-color-gray-6'>담은 메뉴</span>
                <div
                  className='TO-button-5-small text-color-gray flex center pointer'
                  style={{ width: "fit-content", gap: 8 }}
                  onClick={() => {
                    setOrderWindowState(false);
                  }}
                >
                  주문창 닫기
                  <img
                    src={"/assets/images/menu/close_black.svg"}
                    alt='close icon'
                    style={{ width: 24, height: 24 }}
                  />
                </div>
              </div>
              {cartData!.length > 0 ? (
                <>
                  <div
                    className='flex row justify-content-between'
                    style={{ height: "auto", margin: "8px 0" }}
                  >
                    <span></span>
                    <div
                      className='delete-btn TO-button-5-small pointer'
                      onClick={() => {
                        resetCart();
                      }}
                    >
                      전체삭제
                    </div>
                  </div>
                  <div className='scroll' style={{ height: 482 }}>
                    {cartData!.map((v, idx) => {
                      return (
                        <div className='order-wrap'>
                          <div
                            className='flex row justify-content-between'
                            style={{ height: "auto", marginBottom: 4 }}
                          >
                            <div className='TO-button-3'>{v.name}</div>
                            <img
                              className='pointer'
                              src={"/assets/images/menu/close_black.svg"}
                              alt='close icon'
                              style={{
                                width: 24,
                                height: 24,
                                alignSelf: "self-start",
                                padding: "0 16px 16px 16px",
                              }}
                              onClick={() => {
                                deleteMenu(v);
                              }}
                            />
                          </div>
                          {v.option &&
                            v.option.map((val) => {
                              return (
                                <div
                                  className='flex row justify-content-between'
                                  style={{ height: "auto" }}
                                >
                                  <div className='TO-option-2 text-color-gray-6'>
                                    {val.name} {val.ea}
                                  </div>
                                  <div className='TO-option-2 text-color-gray-6'>
                                    + {val.price.toLocaleString()}원
                                  </div>
                                </div>
                              );
                            })}
                          <div className='flex row align-items-center'>
                            {cartData && (
                              <ControllerOrder
                                data={cartData}
                                order={v}
                                value={v.ea}
                              />
                            )}
                            <div
                              className='TO-price-4'
                              style={{ paddingTop: 6 }}
                            >
                              {calcProductPrice(idx).toLocaleString()}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div
                  className='flex col center TO-button-2'
                  style={{ color: "#BFBFBF" }}
                >
                  <img
                    src={"/assets/images/menu/empty_cart.svg"}
                    alt='cart icon'
                  />
                  <span>담은 메뉴가 없습니다</span>
                </div>
              )}
            </div>
            <div className='flex col' style={{ height: "auto" }}>
              {cartData!.length > 0 && (
                <div className='flex row justify-content-between TO-button-2 text-color-gray-6'>
                  <div className='flex center' style={{ width: "auto" }}>
                    총
                    <span
                      className='TO-price-1 text-color-gray-3'
                      style={{ margin: "0 4px" }}
                    >
                      {calcTotalEa()?.toLocaleString()}
                    </span>
                    개
                  </div>
                  <div className='flex center' style={{ width: "auto" }}>
                    총
                    <span
                      className='TO-price-2 text-color-gray-3'
                      style={{ margin: "0 4px" }}
                    >
                      {calcTotalAmount()?.toLocaleString()}
                    </span>
                    원
                  </div>
                </div>
              )}

              <div
                className='flex row justify-content-between relative'
                style={{ gap: 8, height: "auto" }}
              >
                <div
                  className='basic-btn gray TO-button-1 relative pointer'
                  onClick={() => {
                    navigate("/menu/order/history");
                  }}
                >
                  주문서
                </div>
                {isTooltip && (
                  <div className='tooltip-box TO-button-2'>
                    주문은 여기서 확인
                    <img
                      src={"/assets/images/menu/close_gray.svg"}
                      alt='close icon'
                      onClick={() => {
                        setIsTooltip(false);
                      }}
                    />
                    <div className='triangle'></div>
                  </div>
                )}
                {calcTotalEa() > 0 ? (
                  <div
                    className='basic-btn TO-button-1 pointer'
                    style={{
                      padding: 12,
                      minWidth: "fit-content",
                    }}
                    onClick={() => {
                      setIsOrder(true);
                    }}
                  >
                    주문하기
                  </div>
                ) : (
                  <div
                    className='basic-btn TO-button-1 red-disabled'
                    style={{
                      padding: 12,
                      minWidth: "fit-content",
                    }}
                  >
                    주문하기
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            className='floating-btn-cart T24M'
            style={{ color: "white" }}
            onClick={() => {
              setOrderWindowState(true);
            }}
          >
            <img
              src={"/assets/images/menu/cart.svg"}
              alt='cart icon'
              style={{ marginBottom: 2, marginRight: 10 }}
            />
            메뉴
          </div>
        )}
      </div>
      {langPopup && <PopupLanguageList action={popupControl} />}
      {servicePopup && <IntroOrdered action={serviceControl} />}
      {optionPopupView && (
        <PopupOption data={optionPopupView} action={optionControl} />
      )}
      {isOrder && <OrderConfirm />}
    </>
  );
}
export default MenuMain;
